import React from 'react';
import Icon9 from '../../../assets/images/icon5.svg';
import Icon10 from '../../../assets/images/icon6.svg';
import Icon11 from '../../../assets/images/icon7.svg';
import Icon12 from '../../../assets/images/icon8.svg';
import Image from "../../elements/Image";
import Button from "../../form/Button";
import CareerCards from "./CareerCards";

const cards = [
  {
    icon: Icon9,
    title: "Community Manager",
    icon2 : Icon10,
    tag: "Accountant",
  },
   
]

const Career = ({data}) => {
  return (
    <>
      <div className="relative flex flex-col py-28">
        <h4 className="text-xl font-semibold mb-2 text-primary uppercase text-center leading-5">{data.SubTitle}</h4>
        <h2 className="text-5xl font-semibold text-center text-white leading-tight  max-w-[680px] mb-10 mx-auto">{data.title}</h2>
        <div className="relative flex flex-col gap-5">
          <CareerCards/> 
        </div>
        <div className="relative mx-auto mt-10">
          <Button
            type="button"
            buttonLink={"#"}
            buttonLabel="JOIN OUR TEAM"
            buttonClasses={"!px-7"}
          />
        </div>
      </div>
    </>
  )
}

export default Career